import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=b7335196"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=b7335196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports